export default "__VITE_ASSET__sDN7yCBn__"